import { useContext } from "react";
import DialogAnimate from "src/components/animate/DialogAnimate";
import InfoActionDialog from "src/components/InfoActionDialog";
import useLocales from "src/hooks/useLocales";

import Context from "../Table/context";
import useDeleteUser from "./service/useDeleteUser";

// ----------------------------------------------------------------------

export const DeleteDialog = () => {
	const { state, actions } = useContext(Context);
	const { translate } = useLocales();

	const { deleteUser, isLoading } = useDeleteUser();

	return (
		<DialogAnimate maxWidth={"xs"} onClose={actions.closeDialog} open={state.showDeleteDialog}>
			<InfoActionDialog
				acceptTitle={translate("Borrar cuenta")}
				cancelTitle={translate("Cancelar")}
				description={translate("Se perderá toda la información de esta cuenta.")}
				onAccept={deleteUser}
				onCancel={actions.closeDialog}
				title={translate("¿Estás seguro?")}
				loading={isLoading}
			/>
		</DialogAnimate>
	);
};

export default DeleteDialog;
